<template>
  <div class="home">
    <HelloWorld />
    <LunBo @my-event="xianshi" />
    <div class="article-lie zxwidth">
      <h2>传统企业管理痛点</h2>
      <div class="article-lie-1">
        <div>
          <img src="../assets/image/icon1.png" alt />
          <h5>管理难</h5>
          <p>进销存功能单一老旧，无法实现智 慧零售管理和考核辅助</p>
        </div>
        <div>
          <img src="../assets/image/icon2.png" alt />
          <h5>多系统不互通</h5>
          <p>进销存系统、会员系统、财务系统各自独立，数据难互通，不利管理</p>
        </div>
        <div>
          <img src="../assets/image/icon3.png" alt />
          <h5>查询难</h5>
          <p>数据报表内容与维度单一，无法直 观有效查看，财务加工难度大</p>
        </div>
        <div>
          <img src="../assets/image/icon4.png" alt />
          <h5>成本高</h5>
          <p>门店成本持续增长，人效和坪效难 以管理，毛利提升难</p>
        </div>
      </div>
      <div class="article-lie-2">
        <div>
          <img src="../assets/image/icon5.png" alt />
          <h5>破圈难</h5>
          <p>缺乏线上线下一体化解决工具和运 营能力</p>
        </div>
        <div>
          <img src="../assets/image/icon6.png" alt />
          <h5>获客难</h5>
          <p>缺乏有效的获客、营销方案</p>
        </div>
        <div>
          <img src="../assets/image/icon7.png" alt />
          <h5>运营难</h5>
          <p>会员沉淀、会员运营的工具和手段 缺失，会员活跃度低，粘性差</p>
        </div>
        <div>
          <img src="../assets/image/icon8.png" alt />
          <h5>分销性比低</h5>
          <p>业内B2B分销系统价格高，普通系 统无法满足分销需求</p>
        </div>
      </div>
    </div>
    <div class="article-xinwen zxwidth2">
      <h2>SaaS解决方案六大赋能</h2>
      <div class="article-xinwen1">
        <div class="article-xinwen1z">
          <h2>全场景数字化赋能</h2>
          <p>实时数据/多维报表/数据分析/数据决策/移动APP 会员体系/B2B分销/全渠道运营</p>
          <button @click="xianshi">免费试用</button>
        </div>
        <div class="article-xinwen1y">
          <img src="../assets/image/changjing.png" alt />
        </div>
      </div>
      <div class="article-xinwen2">
        <div class="article-xinwen1z">
          <img src="../assets/image/mendian.png" alt />
        </div>
        <div class="article-xinwen1y">
          <h2>智慧门店管理</h2>
          <p>无纸化开单/进销存/库存预警/财务管理/价保返利 店员考核/新品预售/优惠券促销/评价体系/标签体系</p>
          <button @click="xianshi">免费试用</button>
        </div>
      </div>
      <div class="article-xinwen3">
        <div class="article-xinwen1z">
          <h2>线上线下融合运营</h2>
          <p>SaaS云计算/小程序商城/公众号/企业微信/实体门 店引流/社群导流和运营</p>
          <button @click="xianshi">免费试用</button>
        </div>
        <div class="article-xinwen1y">
          <img src="../assets/image/yunying.png" alt />
        </div>
      </div>
      <div class="article-xinwen4">
        <div class="article-xinwen1z">
          <img src="../assets/image/zuzhi.png" alt />
        </div>
        <div class="article-xinwen1y">
          <h2>企业组织变革</h2>
          <p>常规门店组织/分公司组织/合伙人组织/建立分享机制 组织效能测评/员工能力测评</p>
          <button @click="xianshi">免费试用</button>
        </div>
      </div>
      <div class="article-xinwen5">
        <div class="article-xinwen1z">
          <h2>会员运营管理</h2>
          <p>私域流量/精准获客/会员画像/会员运营/会员储值 积分商城/会员礼包/精准服务</p>
          <button @click="xianshi">免费试用</button>
        </div>
        <div class="article-xinwen1y">
          <img src="../assets/image/huiyuan.png" alt />
        </div>
      </div>
      <div class="article-xinwen6">
        <div class="article-xinwen1z">
          <img src="../assets/image/funeng.png" alt />
        </div>
        <div class="article-xinwen1y">
          <h2>运营赋能</h2>
          <p>营销策划服务/大节促销服务/商学院培训/中关村资 讯库/私董会服务/定制功能开发</p>
          <button @click="xianshi">免费试用</button>
        </div>
      </div>
    </div>
    <div class="article-jieshao">
      <img src="../assets/image/bg1.png" alt="">
      <div class="article-jieshao1">
        <h2>性能强大、安全、稳定的SaaS产品</h2>
        <p>系统稳定高于一切，让商家经营有保障，消费者购物更放心</p>
        <div class="img1">
          <!-- <img src="../assets/image/xingneng.png" alt /> -->
          <div class="img11">
            <div class="img12">
              <img src="../assets/image/xingneng1.png" alt />
            </div>
            <div class="img13">
              <h3>关键数据 实时读写备份</h3>
              <p>3000台物理服务器运维调动能力</p>
              <p>秒级扩容缩容 支持千量级并发</p>
            </div>
          </div>
          <div class="img11">
            <div class="img12">
              <img src="../assets/image/xingneng2.png" alt />
            </div>
            <div class="img13">
              <h3>主动预警监测 严格权限管理</h3>
              <p>单一时刻并发量 10000单/分钟</p>
              <p>生产/办公网络完全隔离</p>
            </div>
          </div>
          <div class="img11">
            <div class="img12">
              <img src="../assets/image/xingneng3.png" alt />
            </div>
            <div class="img13">
              <h3>采用最新互联网算法</h3>
              <p>拥有大业务量浮点运算能力</p>
              <p>全网海量大数据的穿透分析实战经验</p>
            </div>
          </div>
        </div>
        <div class="button1">
          <button @click="xianshi">免费试用</button>
        </div>
      </div>
    </div>
    <h2 class="h2t">他们都在用</h2>
    <div class="shangja">
      <img src="../assets/image/kehulogo.png" alt />
    </div>
    <transition :appear="true">
      <div class="tanchu" v-if="xianshia">
        <h3>
          申请试用
          <i @click="xianshia=false" class="glyphicon glyphicon-remove" aria-hidden="true"></i>
        </h3>
        <form @submit.prevent="saveProduct(xinxi)">
          <!-- <form action="https://adminapiv2.zolerp.cn//api/Examine/IntentionalCustomerAdd" method="post"> -->
          <span class="span1">*</span>
          <input
            id="uesrname"
            type="text"
            placeholder="您的姓名"
            v-model="xinxi.Contacts"
            required
            maxlength="15"
          />
          <span class="a1 span1">*</span>
          <input
            id="tele"
            type="text"
            placeholder="您的手机"
            v-model="xinxi.Phone"
            required
            pattern="^1\d{10}$"
            maxlength="11"
          />
          <span class="a2 span1">*</span>
          <input
            id="confirmCode"
            class="yabzeng"
            type="text"
            placeholder="手机验证码"
            v-model="xinxi.VerificationCcode"
            required
            maxlength="6"
          />
          <span v-if="xinxi.Phone.length==11">
            <input
              type="button"
              class="huqv"
              value="获取验证码"
              @click="huoqu(xinxi.Phone)"
              v-if="daojis"
            />
            <input
              type="button"
              class="huqv"
              style="background-color: #666666;"
              :value="count"
              v-else
            />
          </span>
          <span v-else>
            <input type="button" class="huqv" style="background-color: #666666;" value="获取验证码" />
          </span>
          <span class="a3 span1">*</span>
          <input
            id="province"
            type="text"
            placeholder="您的省份"
            v-model="xinxi.Address"
            required
            maxlength="20"
          />
          <span class="a4 span1">*</span>
          <input
            id="company"
            type="text"
            placeholder="您的公司名称"
            v-model="xinxi.CorporateName"
            required
            maxlength="20"
          />
          <p style="color: red; font-size: 10px;padding-left: 25px; margin-top: 5px;">{{cashou}}</p>
          <button>提交</button>
        </form>
      </div>
    </transition>
    <Footer />
  </div>
</template>





<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import HelloWorld from "@/components/top-header";
import LunBo from "@/components/lunbo";
import Footer from "@/components/footer";
import axios from "axios";
export default {
  name: "Home",
  //import引入的组件需要注入到对象中才能使用
  components: {
    HelloWorld,
    LunBo,
    Footer,
  },
  data() {
    //这里存放数据
    return {
      xianshia: false,
      TempToken:"",
      xinxi: {
        CorporateName: "",
        Phone: "",
        Address: "",
        Contacts: "",
        VerificationCcode: "",
      },
      UserName: "",
      tempToken: "",
      token: "",
      cashou: "",
      daojis: true,
      show: true,
      count: '',
      timer: null,
    };
  },

  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合

  methods: {
    // tijiao() {
    //   console.log(this.xinxi);
    // },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.daojis = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.daojis = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    huoqu(e) {
      // console.log(this.xinxi.Phone.length);
      // console.log(e.length);
      if (this.xinxi.Phone.length == 11) {
        // console.log('发送');
        let a = `Phone=${e}`;

        axios
          .post("https://adminapiv2.zolerp.cn//api/Examine/GetSendRegisterToken", a )
          .then((response) => {
            // console.log( response.data.Data)
            let data = response.data.Data;
            this.cashou = response.data.Message;
            this.fashong(data.token,data.tempToken, data.UserName,data.CompanyCode );
          });
      } else {
        alert("请输入正确的手机号");
      }
    },
    fashong(a, e, v, d) {
      let b = `token=${a}&tempToken=${e}&UserName=${v}&CompanyCode=${d}`;
      axios
        .post("https://apiv2.zolerp.cn//api/User/SendVerfiyCodeRegister", b)
        .then((response) => {
          console.log(response.data.Message);
          this.cashou = response.data.Message;
          this.TempToken = response.data.Data.tempToken
          this.getCode()
          this.daojis=false
        });
    },

    xianshi() {
      this.cashou=""
      this.daojis = true;
      this.xinxi.CorporateName = "";
      this.xinxi.Phone = "";
      this.xinxi.Address = "";
      this.xinxi.Contacts = "";
      this.xinxi.VerificationCcode = "";
      this.xianshia = !this.xianshia;
    },
    saveProduct(xinxi) {
      xinxi.TempToken = this.TempToken
      // console.log(xinxi);
      // var jsData1 = `CorporateName=${xinxi.CorporateName}&Phone=${xinxi.Phone}&Address=${xinxi.Address}&Contacts=${xinxi.Contacts}&VerificationCcode=${xinxi.VerificationCcode}`;
      var jsData1 = `CorporateName=${xinxi.CorporateName}&Phone=${xinxi.Phone}&Address=${xinxi.Address}&Contacts=${xinxi.Contacts}&VerificationCcode=${xinxi.VerificationCcode}&TempToken=${xinxi.TempToken}`;
      // console.log(jsData1);
      axios
        .post(
          "https://adminapiv2.zolerp.cn//api/Examine/IntentionalCustomerAdd",
          jsData1
        )
        .then((response) => {
          // console.log(response);
          if(this.TempToken){
          alert(response.data.Message);
            this.xianshia = false;
          }else{
          alert(response.data.Message);

          }
        });
    },
  },
};
</script>
<style lang='less' scoped>
// .tanchua{
//   position: fixed;
//   right: 34px;
//   bottom: 34px;
// }

  button{
    &:focus{
      outline: medium;
    }
  }
.tanchu {
  width: 290px;
  height: 450px;
  background-color: #ffffff;
  border: 1px solid #3366ff;
  position: fixed;
  right: 34px;
  bottom: 34px;
  // bottom: -400px;

  h3 {
    background-color: #3366ff;
    margin: 0px;
    height: 50px;
    width: 290px;
    line-height: 50px;
    font-size: 16px;
    color: #ffffff;
    padding-left: 25px;
    i {
      position: absolute;
      right: 30px;
      top: 17px;
    }
  }
  .span1 {
    position: absolute;
    color: red;
    font-size: 16px;
    top: 80px;
    left: 32px;
  }
  .a1 {
    position: absolute;
    top: 140px;
    left: 32px;
  }
  .a2 {
    position: absolute;
    top: 200px;
    left: 32px;
  }
  .a3 {
    position: absolute;
    top: 260px;
    left: 32px;
  }
  .a4 {
    position: absolute;
    top: 320px;
    left: 32px;
  }
  input {
    width: 240px;
    height: 44px;
    margin-left: 22px;
    margin-top: 16px;
    padding-left: 23px;
    border: 1px solid #e5e5e5;
    font-size: 14px;
    color: #999999;
    &:hover,
    &:active,
    &:focus{
      outline: 0;
      border-radius: 10px;
      border: 1px #0066cc solid;
      // outline:medium;
    }
  }
  button {
    width: 240px;
    height: 44px;
    border: 0px;
    line-height: 44px;
    text-align: center;
    margin-top: 0px;
    margin-left: 25px;
    background-color: #3366ff;
    color: #fffefe;
      &:focus{
      outline: medium;
    }
  }
  .yabzeng {
    width: 140px;
  }
  .huqv {
    width: 90px;
    height: 44px;
    margin-left: 4px;
    padding-left: 2px;
    background-color: #3366ff;
    color: #fffefe;
  }
}

.v-enter {
  opacity: 0;
  bottom: -400px;
}

.v-enter-active {
  transition: all 1s linear;
}
.v-leave-active {
  transition: all 1s linear;
}

.v-leave-to {
  opacity: 0;
  bottom: -400px;
}

.article-lie {
  width: 1200px;
  height: 560px;
  background-color: #ffffff;
  // border: 1px solid red;
  margin: 45px auto;
  h2 {
    font-size: 32px;
    text-align: center;
    // margin-bottom: 52px;
  }
  .article-lie-1 {
    margin-top: 52px;
    width: 100%;
    height: 168px;
    // border: 1px solid red;
    display: flex;
    justify-content: space-between;
    div {
      // border: 1px solid red;
      width: 183px;
      img {
        margin-left: 65px;
        width: 54px;
        height: 54px;
      }
      h5 {
        font-size: 16px;
        color: #333333;
        text-align: center;
        border: 20px 0px;
      }
      p {
        font-size: 12px;
        color: #999999;
        line-height: 22px;
        text-align: center;
      }
    }
  }
  .article-lie-2 {
    margin-top: 65px;
    width: 100%;
    height: 168px;
    // border: 1px solid red;
    display: flex;
    justify-content: space-between;
    div {
      // border: 1px solid red;
      width: 183px;
      img {
        margin-left: 65px;
        width: 54px;
        height: 54px;
      }
      h5 {
        font-size: 16px;
        color: #333333;
        text-align: center;
        border: 20px 0px;
      }
      p {
        font-size: 12px;
        color: #999999;
        line-height: 22px;
        text-align: center;
      }
    }
  }
}
.article-xinwen {
  width: 1200px;
  height: 2500px;
  // border: 1px solid red;
  margin: 45px auto;
  h2 {
    font-size: 32px;
    text-align: center;
    margin-bottom: 33px;
  }
  .article-xinwen1 {
    width: 100%;
    height: 386px;
    // border: 1px solid red;
    .article-xinwen1y {
      margin-top: 30px;
      // border: 1px solid red;

      width: 646px;
      float: right;
      height: 386px;
      img {
        width: 100%;
      }
    }
    .article-xinwen1z {
      width: 360px;
      float: left;
      height: 386px;
      // border: 1px solid red;
      text-align: left;
      padding-top: 62px;
      h2 {
        text-align: left;
        color: #2c3a46;
        font-size: 20px;
        line-height: 22px;
      }
      p {
        font-size: 16px;
        line-height: 30px;
        height: 30px;
        color: #999999;
      }
      button {
        color: #ffffff;
        font-size: 16px;
        margin-top: 52px;
        width: 142px;
        height: 42px;
        background-color: #3366ff;
        border: 0px;
        transition: background 1s;
      }
    }
  }
  .article-xinwen2 {
    width: 100%;
    height: 356px;
    // border: 1px solid red;
    .article-xinwen1z {
      width: 570px;
      float: left;
      height: 356px;
      img {
        width: 100%;
      }
    }
    .article-xinwen1y {
      width: 370px;
      float: right;
      height: 386px;
      padding-top: 50px;
      h2 {
        text-align: left;
        color: #2c3a46;
        font-size: 20px;
        line-height: 22px;
      }
      p {
        font-size: 16px;
        line-height: 30px;
        height: 30px;
        color: #999999;
      }
      button {
        color: #ffffff;
        font-size: 16px;
        margin-top: 52px;
        width: 142px;
        height: 42px;
        background-color: #3366ff;
        border: 0px;
        transition: background 1s;
      }
    }
  }
  .article-xinwen3 {
    width: 100%;
    height: 430px;
    // border: 1px solid red;
    .article-xinwen1y {
      width: 620px;
      float: right;
      height: 430px;
      img {
        width: 100%;
      }
    }
    .article-xinwen1z {
      width: 366px;
      float: left;
      height: 430px;
      // border: 1px solid red;
      text-align: left;
      padding-top: 119px;
      h2 {
        text-align: left;
        color: #2c3a46;
        font-size: 20px;
        line-height: 22px;
      }
      p {
        font-size: 16px;
        line-height: 30px;
        height: 30px;
        color: #999999;
      }
      button {
        color: #ffffff;
        font-size: 16px;
        margin-top: 52px;
        width: 142px;
        height: 42px;
        background-color: #3366ff;
        border: 0px;
        transition: background 1s;
      }
    }
  }
  .article-xinwen4 {
    width: 100%;
    height: 400px;
    .article-xinwen1z {
      width: 570px;
      float: left;
      height: 356px;
      img {
        width: 100%;
      }
    }
    .article-xinwen1y {
      width: 370px;
      float: right;
      height: 386px;
      padding-top: 50px;
      h2 {
        text-align: left;
        color: #2c3a46;
        font-size: 20px;
        line-height: 22px;
      }
      p {
        font-size: 16px;
        line-height: 30px;
        height: 30px;
        color: #999999;
      }
      button {
        color: #ffffff;
        font-size: 16px;
        margin-top: 52px;
        width: 142px;
        height: 42px;
        background-color: #3366ff;
        border: 0px;
        transition: background 1s;
      }
    }
  }
  .article-xinwen5 {
    width: 100%;
    height: 440px;
    // border: 1px solid red;
    .article-xinwen1y {
      width: 640px;
      float: right;
      height: 440px;
      img {
        width: 100%;
      }
    }
    .article-xinwen1z {
      width: 360px;
      float: left;
      height: 440px;
      // border: 1px solid red;
      text-align: left;
      padding-top: 110px;
      h2 {
        text-align: left;
        color: #2c3a46;
        font-size: 20px;
        line-height: 22px;
      }
      p {
        font-size: 16px;
        line-height: 30px;
        height: 30px;
        color: #999999;
      }
      button {
        color: #ffffff;
        font-size: 16px;
        margin-top: 52px;
        width: 142px;
        height: 42px;
        background-color: #3366ff;
        border: 0px;
        transition: background 1s;
      }
    }
  }
  .article-xinwen6 {
    width: 100%;
    height: 320px;
    .article-xinwen1z {
      width: 570px;
      float: left;
      height: 356px;
      img {
        width: 100%;
      }
    }
    .article-xinwen1y {
      width: 370px;
      float: right;
      height: 386px;
      padding-top: 50px;
      h2 {
        text-align: left;
        color: #2c3a46;
        font-size: 20px;
        line-height: 22px;
      }
      p {
        font-size: 16px;
        line-height: 30px;
        height: 30px;
        color: #999999;
      }
      button {
        color: #ffffff;
        font-size: 16px;
        margin-top: 52px;
        width: 142px;
        height: 42px;
        background-color: #3366ff;
        border: 0px;
        transition: background 1s;
      }
    }
  }
}
.article-jieshao {
  width: 100%;
  height: 490px;
  margin-top: 80px;
  // border: 1px solid black;
  position: relative;
  margin: 0px auto;
  img{
    width: 100%;
    height: 100%;
  }
  // background: url("../assets/image/bg1.png") no-repeat 1px 1px;
  .article-jieshao1 {
    // border: 1px solid black;
    position: absolute;
    top: 0px;
    left: 50%;
    margin-left: -600px;
    // margin: 0px auto;
    width: 1200px;
    height: 490px;
    padding-top: 80px;
    h2 {
      text-align: center;
      color: #333333;
      font-size: 32px;
      height: 22px;
      line-height: 22px;
    }
    p {
      margin-top: 20px;
      text-align: center;
      color: #666666;
    }
    .img1 {
      margin-top: 82px;
      margin-left: 120px;
      width: 1050px;
      height: 66px;
      // border: 1px solid black;
      display: flex;
      justify-content: space-between;
      div {
        width: 280px;
        // border: 1px solid black;
        height: 66px;
        .img12 {
          width: 62px;
          height: 62px;
          float: left;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .img13 {
          width: 210px;
          // border: 1px solid black;
          height: 62px;
          float: right;
          text-align: left;
          h3 {
            font-size: 16px;
            color: #2c3946;
            margin: 0;
            text-align: left;
          }
          p {
            color: #999999;
            font-size: 12px;
            margin: 5px 0;
            text-align: left;
          }
        }
      }
      // img {
      //   width: 100%;
      // }
    }
    .button1 {
      width: 100%;
      text-align: center;
      button {
        width: 142px;
        height: 42px;
        background-color: #3366ff;
        color: #ffffff;
        font-size: 16px;
        border: 0px;
        margin-top: 71px;
        transition: background 1s;
      }
    }
  }
}
.h2t {
  font-size: 32px;
  columns: #333333;
  text-align: center;
  margin-top: 90px;
}
.shangja {
  width: 1100px;
  height: 480px;
  margin: 0px auto;
  margin-top: 30px;
  margin-bottom: 120px;
}
button:hover{
  background-color: #1344d8 !important;
}

@media screen and (max-width: 1600px) {
  .home {
    width: 1600px;
    // background-color: #0ba32c;
  }
}
@media screen and (max-width: 1500px) {
  .home {
    width: 1500px;
    // background-color: #3366ff;
  }
}
@media screen and (max-width: 1400px) {
  .home {
    width: 1400px;
    // background-color: #2508cc;
  }
}
@media screen and (max-width: 1300px) {
  .home {
    width: 1300px;
    // background-color: #2508cc;
  }
}
@media screen and (max-width: 1200px) {
  .home {
    width: 1200px;
    // background-color: #f7118f;
    // background-color: chartreuse;
    // border: 1px solid black;
    // height: 560px;
  }
  // .article-jieshao {
  // width: 1200px;
  // height: 490px;
  // margin-top: 80px;
  // margin: 0px auto;
  // }

}
</style>
